import { useNavigate } from '@tanstack/react-router';
import Button from 'antd/es/button';
import Result from 'antd/es/result';
import type { FC } from 'react';

interface Props {
  reset: () => void;
}

const ErrorPage: FC<Props> = ({ reset }) => {
  const navigate = useNavigate();
  return (
    <Result
      status="500"
      title="Unexpected Error"
      subTitle="Sorry, the page you visited has thrown an unexpected error."
      extra={
        <>
          <Button type="primary" onClick={() => reset()}>
            Retry
          </Button>
          <Button type="primary" onClick={() => navigate({ to: '/' })}>
            Back Home
          </Button>
        </>
      }
    />
  );
};

export default ErrorPage;
